import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/avatar-default.png'


const _withScopeId = n => (_pushScopeId("data-v-6134ad38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "logOffApp" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "userMsg-avatar",
  referrerPolicy: "no-referrer",
  src: _imports_0,
  alt: "avatar"
}, null, -1))
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { style: {"justify-content":"center"} }

import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { ElMessageBox, ElMessage } from 'element-plus'
import { onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { removeWhileList } from '@/apis/login'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const membership = store.getters.membership // 会员等级信息
const userInfo = store.getters.user

onMounted(() => {
  if (!userInfo) {
    tipsLogin()
  }
})

/** 用户未登录，让用户先登录 */
const tipsLogin = () => {
  ElMessageBox.alert('現在ログインしていないことを監視し、ログイン後にこの機能を使用することができます', t('提示'), {
    confirmButtonText: t('去登录'),
    type: 'warning',
    customClass: 'tipsLoginConfirm',
    callback: (action: any) => {
      router.push({ path: 'login_h5', query: { redirect: window.location.href } })
    }
  })
}

/** app注销账户页面-只用于app端，入口不对外开放 */
const logoutAccount = () => {
  ElMessageBox.confirm('この操作をログアウトするとアカウントが永久に削除され、続行するかどうか?', t('提示'), {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消'),
    type: 'warning',
    center: true,
    customClass: 'logOutConfirm'
  }).then(async () => {
    const res = await removeWhileList({})
    if (res.data) {
      ElMessageBox.alert('7～15営業日以内にログアウト完了', t('提示'), {
        confirmButtonText: t('我知道了'),
        type: 'warning',
        customClass: 'tipsLoginConfirm'
      })
    }
  }).catch(() => {

  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(userInfo)?.customerName), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('会员等级')), 1),
          (_unref(membership)?.templateLevel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", null, _toDisplayString(_unref(membership)?.templateLevel ? _unref(membership)?.membershipTemplateName : _unref(t)('未入会')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", null, _toDisplayString(_unref(t)('未登录')), 1)
              ]))
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('邮箱')), 1),
          (_unref(userInfo)?.customerEmail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", null, _toDisplayString(_unref(userInfo)?.customerEmail), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)('未登录')), 1))
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createElementVNode("div", {
            class: "logout-btn",
            onClick: logoutAccount
          }, _toDisplayString(_unref(t)('注销账号')), 1)
        ])
      ])
    ])
  ]))
}
}

})